import React from 'react';
import PropTypes from 'prop-types';
import FontIcon from 'material-ui/FontIcon';
import Divider from 'material-ui/Divider';
import IconButton from 'material-ui/IconButton';
import OrderDetailLoading from 'workOrderComponents/OrderDetailLoading';
import objectAssign from 'object-assign';

const WorkOrderNotification = (props) => {
    const {
        iconColor,
        message,
        icon,
        className,
        textClass,
        children,
        isLoading,
        loadingMessage,
        onRefresh,
        hasData,
        style
    } = props;

    if (isLoading) {
        return (<OrderDetailLoading message={loadingMessage} isLoading={isLoading}/>);
    }

    const mergedStyle = objectAssign(style || {}, {
        display: 'flex',
        alignItems: 'center',
        paddingLeft: '10px'
    });

    let refreshButton = null,
        childrenStyle = null,
        childrenClass = '';

    if ((!message && !children) || !hasData) {
        return null;
    }

    if (onRefresh) {

        childrenStyle = {
            height: '48px'
        };

        childrenClass = 'left valign-wrapper';

        refreshButton = (
            <div className="right right-align">
                <IconButton
                    tooltipPosition="top-right"
                    iconClassName="material-icons"
                    tooltip="Refresh"
                    onTouchTap={onRefresh}>
                    refresh
                </IconButton>

            </div>
        );
    }

    return (
        <div className="row">

            <div className="col s12">

                <Divider/>
                <div style={mergedStyle} className={className}>
                    <FontIcon className={iconColor + ' material-icons'}>
                        {icon}
                    </FontIcon>
                    <div
                        className={textClass}
                        style={{
                        width: '100%',
                        paddingLeft: '10px'
                    }}>
                        {message}
                        <div className={childrenClass} style={childrenStyle}>
                            {children}
                        </div>

                        {refreshButton}
                    </div>
                </div>
            </div>
        </div>

    );
};

WorkOrderNotification.propTypes = {
    message: PropTypes.string,
    textClass: PropTypes.string,
    children: PropTypes.object,
    style: PropTypes.object,
    iconColor: PropTypes.string,
    icon: PropTypes.string,
    className: PropTypes.string,
    onRefresh: PropTypes.func,
    isLoading: PropTypes.bool,
    loadingMessage: PropTypes.string,
    hasData: PropTypes.bool
};

export default WorkOrderNotification;


// WEBPACK FOOTER //
// ./src/components/work-order/WorkOrderNotification.js